<template>
  <div>
    <a-modal
      title="分类管理"
      :width="600"
      :visible="visible"
      :confirmLoading="confirmLoading"
      okText="保存"
      @ok="handleSubmit"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-spin :spinning="confirmLoading">
        <!-- 表单域 -->
        <a-form :form="form">
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="上级分类"
            has-feedback
            v-if="type === 3"
          >
            <a-select
              @change="handleChange"
              v-decorator="[
                'parent_id',
                {rules: [{ required: true, message: '请选择上级分类' }]}
              ]">
              <a-select-option v-for="(item, index) in treeList" :key="index" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="分类名称"
          >
            <a-input
              v-decorator="[
                'name',
                {rules: [{ required: true, message: '输入分类名称' }]}
              ]"
            />
          </a-form-item>

          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="分类说明"
          >
            <a-input
              v-decorator="[
                'description',
                {rules: [{ required:true, message: '输入分类说明' }]}
              ]"
            />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import api from '@/api/manage'
import pick from 'lodash.pick'
import { addAiticleCategory, updateAiticleCategory } from '@/api/manage'

export default {
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      visible: false,
      form: this.$form.createForm(this),
      record: {},
      confirmLoading: false,
      loading: false,
      list: [],
      type: 2,
      parentId: 0
    }
  },
  computed: {
    treeList () {
      const tree = []
      tree.push({
        id: 0,
        name: '作为一级菜单'
      })
      this.list.forEach((val, key) => {
        tree.push({
          id: val.id,
          name: val.name
        })
        if (val.children && val.children.length > 0) {
          val.children.forEach((v, k) => {
            tree.push({
              id: v.id,
              name: '├─' + v.name
            })
          })
        }
      })
      return tree
    }
  },
  methods: {
    show (list, record, type) {
      this.visible = true
      this.$nextTick(() => {
        this.record = record
        this.list = list
        this.type = type
        if (type === 3) {
          this.loadEditInfo(record)
        } else {
          this.parentId = record.id
        }
      })
    },
    handleSubmit () {
      this.confirmLoading = true
      this.form.validateFields((errors, values) => {
        if (!errors) {
          const formData = pick(values, ['name', 'description'])
          formData.parent_id = this.parentId
          if (this.type === 2) {
            this.handleCreate(formData)
          } else if (this.type === 3) {
            formData.id = this.record.id
            this.handleUpdate(formData)
          }
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleCreate (formData) {
      addAiticleCategory(formData)
        .then((res) => {
          this.$emit('ok', formData) // 子组件将数据带到父组件
          this.$message.success(res.msg)
          this.form.resetFields()
          this.visible = false
        }).catch((e) => this.requestFailed(e))
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleUpdate (formData) {
      updateAiticleCategory(formData)
        .then((res) => {
          this.$emit('ok', formData) // 子组件将数据带到父组件
          this.$message.success(res.msg)
          this.form.resetFields()
          this.visible = false
        }).catch((e) => this.requestFailed(e))
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleCancel () {
      this.record = {}
      this.form.resetFields()
      this.visible = false
      this.loading = false
    },
    loadEditInfo (data) {
      new Promise((resolve) => {
        resolve()
      }).then(() => {
        const formData = pick(data, ['parent_id', 'name', 'description'])
        this.form.setFieldsValue(formData)
        this.parentId = data.parent_id
      })
    },
    handleChange (value) {
      this.parentId = value
    },

    requestFailed (err) {
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    }
  }
}
</script>

<style lang="less" scoped>
  .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
